import CalendarTable from './calender';
import ExampleBox from './ExampleBox';

const EventPayout = () => {
  return (
    <div className="font-sans text-gray-800 bg-white max-w-5xl mx-auto">
      <Header />
      <MainContent />
      {/* <Footer /> */}
    </div>
  );
};

const Header = () => {
  return (
    <header className="bg-[#048998] text-white py-10 px-8 border-b-4 border-[#048998]/50 relative overflow-hidden rounded-b-lg shadow-lg">
      <div className="relative z-10">
        <h1 className="text-4xl mb-2 font-semibold">Understanding Your Payment Terms</h1>
        <p>ClickHunts Affiliate Network Payment Schedule</p>
      </div>
      
      {/* Decorative circle */}
      <div className="absolute -right-12 -bottom-12 w-48 h-48 bg-white/10 rounded-full"></div>
    </header>
  );
};

const MainContent = () => {
  return (
    <main className="px-8 py-8">
      <Introduction />
      <EventPayoutExplanation />
      <ExamplesWithCalendar />
      <NetTermsExplanation />
      {/* <PaymentMethods />
      <ContactSection /> */}
    </main>
  );
};

const Introduction = () => {
  return (
    <div className="bg-gray-50 p-6 rounded-lg mb-8 border-l-4 border-[#048998]">
      <p>One of the most common questions our affiliates ask is "When will I get paid?" This guide explains our payment terms in detail to help you understand exactly when to expect your commissions.</p>
    </div>
  );
};

const EventPayoutExplanation = () => {
  return (
    <div>
      <SectionTitle>Payment Terms Explained</SectionTitle>
      
      <div className="bg-white rounded-lg p-5 my-5 shadow border-l-3 border-[#048998] italic">
        <p>"I understand what 'weekly' and 'monthly' mean, but what exactly is 'Net 7' or 'Net 15'?"</p>
      </div>
      
      <div className="mb-8 bg-white rounded-lg p-6 shadow">
        <p><span className="text-[#048998] font-semibold">"Weekly" and "Monthly"</span> refer to your payment <strong>frequency</strong> - how often we process payments:</p>
        <ul className="list-inside ml-5 my-4">
          <li className="mb-2">For <strong>weekly payments</strong>, the billing week starts on Monday and ends on Sunday</li>
          <li className="mb-2">For <strong>monthly payments</strong>, the billing month starts on the 1st and ends on the last day of the month</li>
        </ul>
        
        <p><span className="text-[#048998] font-semibold">"Net 7", "Net 15", and "Net 30"</span> refer to the <strong>delay</strong> between the end of a billing period and when payment is sent:</p>
        <ul className="list-inside ml-5 my-4">
          <li className="mb-2"><strong>Net 7</strong> = Payment 7 days after the billing period ends</li>
          <li className="mb-2"><strong>Net 15</strong> = Payment 15 days after the billing period ends</li>
          <li className="mb-2"><strong>Net 30</strong> = Payment 30 days after the billing period ends</li>
        </ul>
      </div>
    </div>
  );
};

const ExamplesWithCalendar = () => {
  return (
    <div>
      <SectionTitle>Examples With Calendar</SectionTitle>
      
 <div className="grid md:grid-cols-2 gap-5 my-8">
  {/* First Column - 2 rows with equal height distribution */}
  <div className="flex flex-col gap-5">
    <div className="flex-1">
      <ExampleBox 
        title="Weekly Net 7 Example" 
        content={
          <>
            <div className="bg-gray-50 p-4 my-4 rounded-lg">
              <p>Commissions earned during July 1-7 (highlighted) will be paid on July 15:</p>
              <CalendarTable 
                highlightDays={[1,2,3,4,5,6,7]}
                paymentDate={15}
                numberOfWeeks={3}
              />
              {/* <p className="italic text-sm">Note: Payment is sent 7 days after the end of the billing period (July 8-14), on July 15</p> */}
            </div>
          </>
        }
      />
    </div>
    
    <div className="flex-1">
      <ExampleBox 
        title="Bi-Weekly Net 7 Example" 
        content={
          <>
            {/* <p>With <span className="text-[#048998] font-semibold">Bi-Weekly Net 7</span> payment terms, commissions are paid every two weeks:</p> */}
            
            <div className="bg-gray-50 p-4 my-4 rounded-lg">
              {/* <p>Commissions earned during July 1-14 (highlighted) will be paid on July 22:</p> */}
              <CalendarTable 
                highlightDays={[1,2,3,4,5,6,7]}
                paymentDate={7}
                numberOfWeeks={1}
              />
            </div>
          </>
        }
      />
    </div>
  </div>
  
  {/* Second Column - 1 row spanning full height */}
  <div className="flex">
    <div className="flex-1">
      <ExampleBox 
        title="Monthly Net 7 Example" 
        content={
          <>
            <p>With <span className="text-[#048998] font-semibold">Monthly Net 7</span> payment terms, all commissions for the month of July will be paid 7 days after the end of July:</p>
            
            <div className="bg-gray-50 p-4 my-4 rounded-lg">
              <p>Commissions earned during all of July (highlighted) will be paid on August 7:</p>
              <CalendarTable 
                highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]}
                paymentDate={null}
                numberOfWeeks={5}
              />
              
              <CalendarTable 
                isNextMonth={true}
                paymentDate={7}
                numberOfWeeks={2}
              />
            </div>
          </>
        }
      />
    </div>
  </div>
</div>


      <div className="grid md:grid-cols-2 gap-5 my-8">
        
        <ExampleBox 
          title="Monthly Net 15 Example" 
          content={
            <>
              <p>With <span className="text-[#048998] font-semibold">Monthly Net 15</span> payment terms, all commissions for the month of July will be paid 15 days after the end of July:</p>
              
              <div className="bg-gray-50 p-4 my-4 rounded-lg">
                <p>Commissions earned during all of July (highlighted) will be paid on August 15:</p>
                <CalendarTable 
                  highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]}
                  paymentDate={null}
                  numberOfWeeks={5}
                />
                
                  <CalendarTable 
                  paymentDate={15}
                  numberOfWeeks={5}
                />
              </div>
            </>
          }
        />
        <ExampleBox
          title="Monthly Net 30 Example" 
          content={
            <>
              <p>With <span className="text-[#048998] font-semibold">Monthly Net 7</span> payment terms, all commissions for the month of July will be paid 7 days after the end of July:</p>
              
              <div className="bg-gray-50 p-4 my-4 rounded-lg">
                <p>Commissions earned during all of July (highlighted) will be paid on August 7:</p>
                <CalendarTable 
                  highlightDays={[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]}
                  paymentDate={null}
                  numberOfWeeks={5}
                />
                
                
                  <CalendarTable
                  paymentDate={31}
                  numberOfWeeks={5}
                />
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};

const NetTermsExplanation = () => {
  return (
    <div className="mb-8 bg-white rounded-lg p-6 shadow">
      <h3 className="text-xl font-semibold text-[#048998] mb-4">Monthly Net 15 & Net 30</h3>
      <p><span className="text-[#048998] font-semibold">Monthly Net 15</span> payment terms would have all commissions from July paid on August 15 (15 days after the end of July).</p>
      <p className="mt-4"><span className="text-[#048998] font-semibold">Monthly Net 30</span> payment terms would have all commissions from July paid on August 30 (30 days after the end of July).</p>
    </div>
  );
};




// Reusable Components
const SectionTitle = ({ children }) => {
  return (
    <h2 className="text-2xl font-semibold mt-10 mb-5 text-[#048998] pb-2 border-b-2 border-[#048998]/10">
      {children}
    </h2>
  );
};

export default EventPayout;